import { put, takeLatest } from 'redux-saga/effects';

import { apiCall } from 'Modules/core/api';
import { augmentSaga } from 'Modules/core/redux';
import { withErrorHandler } from 'Modules/core/messaging';

import { monitoring } from '../../api';
import { monitoringActions } from './actions';


export function* getMonitoringList() {
    const data = yield apiCall(monitoring.list);
    yield put(monitoringActions.setMonitoringList(data));
}

export const sagas = [
    takeLatest(`${monitoringActions.getMonitoringList}`, augmentSaga(
        getMonitoringList,
        withErrorHandler('monitoring.getMonitoringList'),
    )),
];
